// Description: Callback page that will redirect the user to the main page after the login with Google or Facebook
// Updated: 11/07/2025
// Author: Vitor de Jesus

// React
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Material UI Components

// Components and functions for the project
import { notify } from '../../utils/utils';

const CallbackPage = () => {
    const [code, setCode] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    // const { login } = useAuth(); // Ative quando estiver usando contexto

    useEffect(() => {
        console.log("URL atual:", window.location.href);
        console.log("Search params:", window.location.search);
        const query = new URLSearchParams(window.location.search);
        const codeFromUrl = query.get('code');
        console.log("Code extraído:", codeFromUrl);

        if (codeFromUrl) {
            setCode(codeFromUrl);
            return;
        };

        notify("Error", "Ocorreu um erro ao fazer login", true);
        navigate("/login");
    }, []);

    useEffect(() => {
        if (!code) return;

        fetchToken(code);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]);

    const fetchToken = async (codeParam) => {
        setLoading(true);

        const tokenUrl = `${process.env.REACT_APP_COGNITO_URL}/oauth2/token`;
        const params = new URLSearchParams();
        params.append('grant_type', 'authorization_code');
        params.append('client_id', process.env.REACT_APP_COGNITO_CLIENT_ID);
        params.append('code', codeParam);
        params.append('redirect_uri', process.env.REACT_APP_FRONTEND_URL + '/callback');

        try {
            const response = await fetch(tokenUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: params.toString(),
            });

            const data = await response.json();

            if (response.ok) {
                const expirationTime = Date.now() + 30 * 60 * 1000;

                const authTokens = {
                    accessToken: data.access_token,
                    refreshToken: data.refresh_token,
                    idToken: data.id_token,
                    expiresAt: expirationTime,
                };

                console.log('authTokens', authTokens);

                localStorage.setItem("expiration_time", authTokens.expiresAt);
                localStorage.setItem("jwt_token", authTokens.accessToken);
                localStorage.setItem("idToken", authTokens.idToken);
                localStorage.setItem("refreshToken", authTokens.refreshToken);

                window.location.href = "/";
            } else {
                sessionStorage.setItem('auth_error', 'Ocorreu um erro ao fazer login');
                notify("Error", "Ocorreu um erro ao fazer login", true);
                navigate('/login');
            }
        } catch (err) {
            sessionStorage.setItem('auth_error', 'Erro inesperado');
            notify("Error", "Erro inesperado", true);
            navigate('/login');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: '100vw',
                backgroundColor: 'transparent',
            }}
        >
            <div
                style={{
                    backgroundColor: '#fff',
                    padding: '2rem 3rem',
                    borderRadius: '8px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    fontSize: '1.25rem',
                    fontWeight: 500,
                }}
            >
                Redirecionando...
            </div>
        </div>

    );
};

export default CallbackPage;
